import React from 'react';

import { ReactComponent as ShieldLogoIcon } from './source/shield-logo.svg';
import { Root } from './shared/styled';

import type { IconProps } from './shared/types';

const ShieldLogo = (props: IconProps): React.ReactElement => {
    return (
        <Root {...props}>
            <ShieldLogoIcon />
        </Root>
    );
};

export { ShieldLogo };
